import { RECEIVE_SUBSCRIPTION_PAYMENTS, REQUEST_SUBSCRIPTION_PAYMENTS } from '../actions'
import { updateOrAddItemsById } from '../helpers'

export default (state = {}, action) => {
    const { type, data } = action
    const { subscriptionId } = data || {}

    switch (type) {
        case REQUEST_SUBSCRIPTION_PAYMENTS: {
            return {
                ...state,
                [subscriptionId]: {
                    isFetching: true,
                    shouldFetch: true,
                },
            }
        }

        case RECEIVE_SUBSCRIPTION_PAYMENTS: {
            const { payments = [] } = data || {}
            const subscriptionPaymentsFromState = state[subscriptionId] || {}
            const { list: subscriptionPaymentListFromState = [] } = subscriptionPaymentsFromState

            return {
                ...state,
                [subscriptionId]: {
                    ...subscriptionPaymentsFromState,
                    list: updateOrAddItemsById({
                        currentItems: subscriptionPaymentListFromState,
                        receivedItems: payments,
                    }),
                    isFetching: false,
                    shouldFetch: false,
                },
            }
        }

        default:
            return state
    }
}
